import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'map',
    loadComponent: () =>
      import('./pages/map/map.component').then((m) => m.MapComponent),
  },
  {
    path: 'news',
    loadComponent: () =>
      import('./pages/news/news.component').then((m) => m.NewsComponent),
    data: {
      breadcrumb: 'News',
    },
  },
  {
    path: 'news/:id',
    loadComponent: () =>
      import('./pages/news-detail/news-detail.component').then(
        (m) => m.NewsDetailComponent
      ),
    data: {
      breadcrumb: 'Dettaglio news',
    },
  },
  {
    path: 'attivita',
    loadComponent: () =>
      import('./pages/activities/activities.component').then(
        (m) => m.ActivitiesComponent
      ),
    data: {
      breadcrumb: 'Attività',
    },
  },
  {
    path: 'news/category/:category',
    loadComponent: () =>
      import('./pages/news-by-category/news-by-category.component').then(
        (m) => m.NewsByCategoryComponent
      ),
    data: {
      breadcrumb: 'News per categoria',
    },
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
